const toolPages = [
  {
    path: '/jpeg-compressor',
    title: 'JPEG Compressor',
    navLabel: 'JPEG',
    subtitle: 'Reduce JPG and JPEG file sizes for websites, email, blogs, and product pages.',
    metaTitle: 'Free JPEG Compressor | CompressImages.org',
    metaDescription:
      'Compress JPG and JPEG images in your browser. Reduce photo file size for faster websites, email, and ecommerce uploads.',
    accept: 'image/jpeg',
    acceptedTypes: ['image/jpeg'],
    outputType: 'image/jpeg',
    outputExtension: 'jpg',
    outputLabel: 'Compressed JPEG',
    quality: 0.72,
    maxDimension: 1600,
    introTitle: 'When to compress JPEG images',
    intro:
      'JPEG is the best everyday format for photos, banners, and product images. Compressing large JPEG files helps pages load faster while keeping images usable for visitors.',
    useCases: [
      'Website hero images and blog photos',
      'Product photos for ecommerce listings',
      'Email attachments and portfolio images',
    ],
    faq: [
      {
        question: 'Will JPEG compression reduce quality?',
        answer:
          'JPEG compression is lossy, so some data is removed. The default setting aims for a smaller file while keeping visible quality high.',
      },
      {
        question: 'Are my JPEG files uploaded?',
        answer:
          'No. The image is processed locally in your browser and is not uploaded to our servers.',
      },
    ],
  },
  {
    path: '/png-compressor',
    title: 'PNG Compressor',
    navLabel: 'PNG',
    subtitle: 'Shrink large PNG graphics by converting them into efficient WebP downloads.',
    metaTitle: 'Free PNG Compressor | CompressImages.org',
    metaDescription:
      'Compress PNG files privately in your browser. Convert large PNG graphics into smaller WebP images for web use.',
    accept: 'image/png',
    acceptedTypes: ['image/png'],
    outputType: 'image/webp',
    outputExtension: 'webp',
    outputLabel: 'Compressed WebP',
    quality: 0.82,
    maxDimension: 1600,
    introTitle: 'Why PNG files get large',
    intro:
      'PNG is useful for sharp graphics and transparency, but file sizes can grow quickly. WebP often keeps similar visual quality with a much smaller download size.',
    useCases: [
      'Transparent graphics and interface images',
      'Screenshots used in documentation',
      'Blog graphics that need smaller web delivery',
    ],
    faq: [
      {
        question: 'Why does this PNG tool output WebP?',
        answer:
          'Browser PNG export does not offer strong quality compression. WebP is usually better for making PNG-style images smaller on the web.',
      },
      {
        question: 'Will transparency be preserved?',
        answer:
          'WebP supports transparency in modern browsers, so transparent PNGs should remain transparent after conversion.',
      },
    ],
  },
  {
    path: '/webp-converter',
    title: 'WebP Converter',
    navLabel: 'WebP',
    subtitle: 'Convert JPEG and PNG images into WebP for faster modern websites.',
    metaTitle: 'Free WebP Converter | CompressImages.org',
    metaDescription:
      'Convert images to WebP in your browser. Create smaller modern image files without uploading your images.',
    accept: 'image/jpeg,image/png,image/webp',
    acceptedTypes: ['image/jpeg', 'image/png', 'image/webp'],
    outputType: 'image/webp',
    outputExtension: 'webp',
    outputLabel: 'WebP Image',
    quality: 0.82,
    maxDimension: 1800,
    introTitle: 'Use WebP for modern performance',
    intro:
      'WebP is a practical default for modern sites because it can reduce file size across photos, screenshots, and graphics while supporting transparency.',
    useCases: [
      'Modern website and landing page images',
      'Blog images where speed matters',
      'Replacing oversized JPEG or PNG assets',
    ],
    faq: [
      {
        question: 'Do all browsers support WebP?',
        answer:
          'Most modern browsers support WebP. If you support very old browsers, keep a JPEG or PNG fallback.',
      },
      {
        question: 'Can I convert WebP back to JPEG?',
        answer:
          'This page focuses on WebP output. Use the main compressor when you need JPEG output.',
      },
    ],
  },
  {
    path: '/compress-image-to-100kb',
    title: 'Compress Image to 100KB',
    navLabel: '100KB',
    subtitle: 'Target a smaller file size for forms, uploads, email, and lightweight pages.',
    metaTitle: 'Compress Image to 100KB Online | CompressImages.org',
    metaDescription:
      'Compress an image toward 100KB in your browser. Useful for upload forms, email, and smaller web assets.',
    accept: 'image/*',
    outputType: 'image/jpeg',
    outputExtension: 'jpg',
    outputLabel: '100KB Target JPEG',
    quality: 0.82,
    maxDimension: 1600,
    targetSizeKb: 100,
    introTitle: 'When a target file size matters',
    intro:
      'Some forms and platforms reject large images. This page tries multiple quality and size settings to produce a JPEG near 100KB while keeping the image usable.',
    useCases: [
      'Profile images and application forms',
      'Email-friendly attachments',
      'Small images for fast mobile pages',
    ],
    faq: [
      {
        question: 'Will every image reach exactly 100KB?',
        answer:
          'No. Very large or detailed images may need stronger resizing to get under 100KB, but the tool will try several compression passes automatically.',
      },
      {
        question: 'Why is the output JPEG?',
        answer:
          'JPEG gives predictable compression for target-size workflows and is widely accepted by upload forms.',
      },
    ],
  },
  {
    path: '/image-resizer',
    title: 'Image Resizer',
    navLabel: 'Resize',
    subtitle: 'Resize oversized images before publishing them online.',
    metaTitle: 'Free Image Resizer | CompressImages.org',
    metaDescription:
      'Resize and compress images in your browser. Reduce dimensions and file size before uploading to a website, shop, or blog.',
    accept: 'image/*',
    outputType: 'image/jpeg',
    outputExtension: 'jpg',
    outputLabel: 'Resized JPEG',
    quality: 0.78,
    maxDimension: 1200,
    introTitle: 'Resize before you compress',
    intro:
      'Most oversized images do not need their original camera dimensions online. Resizing first can reduce file size more than compression alone.',
    useCases: [
      'Large phone and camera photos',
      'Blog images displayed at fixed widths',
      'Faster product and portfolio pages',
    ],
    faq: [
      {
        question: 'What size will the image become?',
        answer:
          'The tool keeps the original aspect ratio and limits the longest side to the page default.',
      },
      {
        question: 'Can I keep the original file?',
        answer:
          'Yes. The original image stays on your device. The download is a new optimized copy.',
      },
    ],
  },
];

export default toolPages;
